export const REGION = "eu-west-2";

export const ADMIN = "Admins";
export const AUDIT = "Auditors";

export const GROUPS = "cognito:groups";

export const PAGE_SIZE = 10;